import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Avatar, ActionList, ActionMenu } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const InlineCode = makeShortcode("InlineCode");
const PropsTablePassthroughPropsRow = makeShortcode("PropsTablePassthroughPropsRow");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <br />
    <Box sx={{
      border: '1px solid',
      borderColor: 'border.default',
      borderRadius: 2,
      padding: 6
    }} mdxType="Box">
  <ActionMenu mdxType="ActionMenu">
    <ActionMenu.Button>Menu</ActionMenu.Button>
    <ActionMenu.Overlay>
      <ActionList mdxType="ActionList">
        <ActionList.Item>
          Copy link
          <ActionList.TrailingVisual>⌘C</ActionList.TrailingVisual>
        </ActionList.Item>
        <ActionList.Item>
          Quote reply
          <ActionList.TrailingVisual>⌘Q</ActionList.TrailingVisual>
        </ActionList.Item>
        <ActionList.Item>
          Edit comment
          <ActionList.TrailingVisual>⌘E</ActionList.TrailingVisual>
        </ActionList.Item>
        <ActionList.Divider />
        <ActionList.Item variant="danger">
          Delete file
          <ActionList.TrailingVisual>⌘D</ActionList.TrailingVisual>
        </ActionList.Item>
      </ActionList>
    </ActionMenu.Overlay>
  </ActionMenu>
    </Box>
    <br />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {ActionMenu} from '@primer/react'
`}</code></pre>
    <br />
    <h2>{`Examples`}</h2>
    <h3>{`Minimal example`}</h3>
    <p><inlineCode parentName="p">{`ActionMenu`}</inlineCode>{` ships with `}<inlineCode parentName="p">{`ActionMenu.Button`}</inlineCode>{` which is an accessible trigger for the overlay. It's recommended to compose `}<inlineCode parentName="p">{`ActionList`}</inlineCode>{` with `}<inlineCode parentName="p">{`ActionMenu.Overlay`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionMenu>
  <ActionMenu.Button>Menu</ActionMenu.Button>

  <ActionMenu.Overlay>
    <ActionList>
      <ActionList.Item onSelect={event => console.log('New file')}>New file</ActionList.Item>
      <ActionList.Item>Copy link</ActionList.Item>
      <ActionList.Item>Edit file</ActionList.Item>
      <ActionList.Divider />
      <ActionList.Item variant="danger">Delete file</ActionList.Item>
    </ActionList>
  </ActionMenu.Overlay>
</ActionMenu>
`}</code></pre>
    <h3>{`With a custom anchor`}</h3>
    <p>{`You can choose to have a different `}<em parentName="p">{`anchor`}</em>{` for the Menu depending on the application's context.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionMenu>
  <ActionMenu.Anchor>
    <IconButton icon={KebabHorizontalIcon} variant="invisible" aria-label="Open column options" />
  </ActionMenu.Anchor>

  <ActionMenu.Overlay>
    <ActionList>
      <ActionList.Item>
        <ActionList.LeadingVisual>
          <PencilIcon />
        </ActionList.LeadingVisual>
        Rename
      </ActionList.Item>
      <ActionList.Item>
        <ActionList.LeadingVisual>
          <ArchiveIcon />
        </ActionList.LeadingVisual>
        Archive all cards
      </ActionList.Item>
      <ActionList.Item variant="danger">
        <ActionList.LeadingVisual>
          <TrashIcon />
        </ActionList.LeadingVisual>
        Delete
      </ActionList.Item>
    </ActionList>
  </ActionMenu.Overlay>
</ActionMenu>
`}</code></pre>
    <h3>{`With Groups`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionMenu>
  <ActionMenu.Button>Open column menu</ActionMenu.Button>

  <ActionMenu.Overlay>
    <ActionList showDividers>
      <ActionList.Group title="Live query">
        <ActionList.Item>
          <ActionList.LeadingVisual>
            <SearchIcon />
          </ActionList.LeadingVisual>
          repo:github/memex,github/github
        </ActionList.Item>
      </ActionList.Group>
      <ActionList.Divider />
      <ActionList.Group title="Layout" variant="subtle">
        <ActionList.Item>
          <ActionList.LeadingVisual>
            <NoteIcon />
          </ActionList.LeadingVisual>
          Table
          <ActionList.Description variant="block">
            Information-dense table optimized for operations across teams
          </ActionList.Description>
        </ActionList.Item>
        <ActionList.Item role="listitem">
          <ActionList.LeadingVisual>
            <ProjectIcon />
          </ActionList.LeadingVisual>
          Board
          <ActionList.Description variant="block">Kanban-style board focused on visual states</ActionList.Description>
        </ActionList.Item>
      </ActionList.Group>
      <ActionList.Divider />
      <ActionList.Group>
        <ActionList.Item>
          <ActionList.LeadingVisual>
            <FilterIcon />
          </ActionList.LeadingVisual>
          Save sort and filters to current view
        </ActionList.Item>
        <ActionList.Item>
          <ActionList.LeadingVisual>
            <FilterIcon />
          </ActionList.LeadingVisual>
          Save sort and filters to new view
        </ActionList.Item>
      </ActionList.Group>
      <ActionList.Divider />
      <ActionList.Group>
        <ActionList.Item>
          <ActionList.LeadingVisual>
            <GearIcon />
          </ActionList.LeadingVisual>
          View settings
        </ActionList.Item>
      </ActionList.Group>
    </ActionList>
  </ActionMenu.Overlay>
</ActionMenu>
`}</code></pre>
    <h3>{`With selection`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`selectionVariant`}</inlineCode>{` on `}<inlineCode parentName="p">{`ActionList`}</inlineCode>{` to create a menu with single or multiple selection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const fieldTypes = [
  {icon: TypographyIcon, name: 'Text'},
  {icon: NumberIcon, name: 'Number'},
  {icon: CalendarIcon, name: 'Date'},
  {icon: SingleSelectIcon, name: 'Single select'},
  {icon: IterationsIcon, name: 'Iteration'}
]

const Example = () => {
  const [selectedIndex, setSelectedIndex] = React.useState(1)
  const selectedType = fieldTypes[selectedIndex]

  return (
    <ActionMenu>
      <ActionMenu.Button aria-label="Select field type" leadingIcon={selectedType.icon}>
        {selectedType.name}
      </ActionMenu.Button>
      <ActionMenu.Overlay width="medium">
        <ActionList selectionVariant="single">
          {fieldTypes.map((type, index) => (
            <ActionList.Item key={index} selected={index === selectedIndex} onSelect={() => setSelectedIndex(index)}>
              <ActionList.LeadingVisual>
                <type.icon />
              </ActionList.LeadingVisual>
              {type.name}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

render(<Example />)
`}</code></pre>
    <h3>{`With External Anchor`}</h3>
    <p>{`To create an anchor outside of the menu, you need to switch to controlled mode for the menu and pass it as `}<inlineCode parentName="p">{`anchorRef`}</inlineCode>{` to `}<inlineCode parentName="p">{`ActionMenu`}</inlineCode>{`. Make sure you add `}<inlineCode parentName="p">{`aria-expanded`}</inlineCode>{` and `}<inlineCode parentName="p">{`aria-haspopup`}</inlineCode>{` to the external anchor:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const Example = () => {
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.createRef()

  return (
    <>
      <Button ref={anchorRef} aria-haspopup="true" aria-expanded={open} onClick={() => setOpen(!open)}>
        {open ? 'Close Menu' : 'Open Menu'}
      </Button>

      <ActionMenu open={open} onOpenChange={setOpen} anchorRef={anchorRef}>
        <ActionMenu.Overlay>
          <ActionList>
            <ActionList.Item>Copy link</ActionList.Item>
            <ActionList.Item>Quote reply</ActionList.Item>
            <ActionList.Item>Edit comment</ActionList.Item>
            <ActionList.Divider />
            <ActionList.Item variant="danger">Delete file</ActionList.Item>
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </>
  )
}

render(<Example />)
`}</code></pre>
    <h3>{`With Overlay Props`}</h3>
    <p>{`To create an anchor outside of the menu, you need to switch to controlled mode for the menu and pass it as `}<inlineCode parentName="p">{`anchorRef`}</inlineCode>{` to `}<inlineCode parentName="p">{`ActionMenu`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const handleEscape = () => alert('you hit escape!')

render(
  <ActionMenu>
    <ActionMenu.Button>Open Actions Menu</ActionMenu.Button>
    <ActionMenu.Overlay width="medium" onEscape={handleEscape}>
      <ActionList>
        <ActionList.Item>
          Open current Codespace
          <ActionList.Description variant="block">
            Your existing Codespace will be opened to its previous state, and you&apos;ll be asked to manually switch to
            new-branch.
          </ActionList.Description>
          <ActionList.TrailingVisual>⌘O</ActionList.TrailingVisual>
        </ActionList.Item>
        <ActionList.Item>
          Create new Codespace
          <ActionList.Description variant="block">
            Create a brand new Codespace with a fresh image and checkout this branch.
          </ActionList.Description>
          <ActionList.TrailingVisual>⌘C</ActionList.TrailingVisual>
        </ActionList.Item>
      </ActionList>
    </ActionMenu.Overlay>
  </ActionMenu>
)
`}</code></pre>
    <h2>{`Props / API reference`}</h2>
    <h3>{`ActionMenu`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" required type="React.ReactElement[]" description={<>
        Recommended: <InlineCode mdxType="InlineCode">ActionMenu.Button</InlineCode> or <InlineCode mdxType="InlineCode">ActionMenu.Anchor</InlineCode> with{' '}
        <InlineCode mdxType="InlineCode">ActionMenu.Overlay</InlineCode>
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="open" type="boolean" defaultValue="false" description={<>
        If defined, will control the open/closed state of the overlay. Must be used in conjuction with{' '}
        <InlineCode mdxType="InlineCode">onOpenChange</InlineCode>.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="onOpenChange" type="(open: boolean) => void" description={<>
        If defined, will control the open/closed state of the overlay. Must be used in conjuction with{' '}
        <InlineCode mdxType="InlineCode">open</InlineCode>.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="anchorRef" type="React.RefObject<HTMLElement>" description="Useful for defining an external anchor" mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`ActionMenu.Button`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" required type="React.ReactElement" mdxType="PropsTableRow" />
  <PropsTablePassthroughPropsRow elementName="Button" isPolymorphic passthroughPropsLink={<Link href="/react/Button" mdxType="Link">Button docs</Link>} mdxType="PropsTablePassthroughPropsRow" />
    </PropsTable>
    <h3>{`ActionMenu.Anchor`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" required type="React.ReactElement" description="Accepts a single child element" mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`ActionMenu.Overlay`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" required type="React.ReactElement | React.ReactElement[]" mdxType="PropsTableRow" />
  <PropsTableRow name="align" type="start | center | end" defaultValue="start" mdxType="PropsTableRow" />
  <PropsTablePassthroughPropsRow elementName="Overlay" passthroughPropsLink={<Link href="/react/Overlay" mdxType="Link">Overlay docs</Link>} mdxType="PropsTablePassthroughPropsRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: true,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: true,
      hasFigmaComponent: true
    }} mdxType="ComponentChecklist" />
    <h2>{`Further reading`}</h2>
    <p><a parentName="p" {...{
        "href": "https://primer.style/design/components/action-list"
      }}>{`Interface guidelines: Action List + Menu`}</a></p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ActionList"
        }}>{`ActionList`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/SelectPanel"
        }}>{`SelectPanel`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/Button"
        }}>{`Button`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      